import Vue from 'vue'
import {searchRole,getRoleInfo,deleteRole,operRole } from '@/api/role'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const role = {
  state: { 
		loading:false
  },

  mutations: {
     
  },

  actions: { 
    DeleteRole ({ commit },record) {
      return new Promise((resolve, reject) => {
        deleteRole(record).then(response => {  
    			 console.log(response)
        	 resolve(response)
        	 }).catch(error => {
        		 reject(error)
         }) 
      })
    },
		GetRoleInfo ({ commit },record) {
      return new Promise((resolve, reject) => {
        getRoleInfo(record).then(response => {  
    			 console.log(response)
        	 resolve(response)
        	 }).catch(error => {
        		 reject(error)
         }) 
      })
    }, 
		OperRole ({ commit },record) {
		  return new Promise((resolve, reject) => {
		    operRole(record).then(response => {  
					 console.log(response)
		    	 resolve(response)
		    	 }).catch(error => {
		    		 reject(error)
		     }) 
		  })
		},
		SearchRole ({ commit },record) {
		  return new Promise((resolve, reject) => {
		    searchRole(record).then(response => {  
					 console.log(response)
		    	 resolve(response)
		    	 }).catch(error => {
		    		 reject(error)
		     }) 
		  })
		},
  }
}

export default role
